/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {service as SurveyTypeService} from "../../../Services/SurveyTypeService";

export class SurveyTypeFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			surveyTypes: []
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		SurveyTypeService.Get()
			.then((x) => {
				this.setState({surveyTypes: x.result});
			});
	}

	@autobind
	getSurveyType() {
		return this.state.surveyTypes.find((x) => x.surveyTypeId == this.props.Value);
	}

	@autobind
	_render() {
		return this.getSurveyType() ? this.getSurveyType().name : "N/A";
	}
}